const initialState = {
  displaySidebarAlbums: false,
  displaySignInModal: false,
  showSidebarAlbums: false
};

export const eventReducer = (state = initialState, action) => {
  switch (action.type) {
    case "DISPLAY_SIDEBAR_ALBUMS": {
      return { ...state, displaySidebarAlbums: action.visible };
    }
    case "SHOW_SIDEBAR_ALBUMS": {
      return { ...state, showSidebarAlbums: action.visible };
    }
    case "DISPLAY_SIGN_IN_MODAL": {
      return { ...state, displaySignInModal: action.visible };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/event.js